/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  Container,
  Breadcrumb,
  BreadcrumbItem,
  CardText,
  CardTitle,
  Card,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Spinner,
} from "reactstrap";
import {
  GoogleMap,
  useJsApiLoader,
  Marker,
  InfoWindow,
  DirectionsRenderer,
} from "@react-google-maps/api";
import "./AlongTheWayToHere.scss";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { showPointList } from "../../utils/action/Action";
import { FiShare2, FiBriefcase } from "react-icons/fi";
import { AiOutlineStar, AiFillStar } from "react-icons/ai";
import { MdLocationOn, MdOutlineNavigateNext } from "react-icons/md";
import { BiDotsVerticalRounded, BiExitFullscreen } from "react-icons/bi";
import swal from "sweetalert";
import {
  addUserFavorite,
  removeUserFavorite,
} from "../../services/favourites.service";
import SelectRouteModal from "../../components/Modals/SelectRouteModal";
import CreateNewRouteModal from "../../components/Modals/CreateNewRouteModal";
import PointsListingModal from "../../components/Modals/PointsListingModal";
import ReportSuggestionModal from "../../components/Modals/ReportSuggestionModal";
import ShareModal from "../../components/Modals/ShareModal";
import { routeDetail, updateRouteDetail } from "../../services/myRoute.service";
import GeoLocation from "../../components/GeoLocation/GeoLocation";
import { useCallback } from "react";
import { deductPoints, getUserPoints } from "../../services/points.service";
import marked_pop from "../../assets/marked_pop.svg";
import { GoHome } from "react-icons/go";

const containerStyle = {
  width: "100%",
  height: "650px",
};

const options = {
  minZoom: 2,
  maxZoom: 17,
  gestureHandling: "greedy",
};

function AlongTheWayToHere({ isUserLoggedIn, getPoints }) {
  const [activeMarker, setActiveMarker] = useState(null);
  const [dropdownMenuOpen, setMenuOpen] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [pointName, setPointName] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showListModal, setShowListModal] = useState(false);
  const [routeName, setRouteName] = useState(null);
  const [showCreateRouteModal, setShowCreateRouteModal] = useState(false);
  const [checkForFavorite, setCheckForFavorite] = useState(null);
  const [route, setRoute] = useState(null);
  const [mkmID, setMkmId] = useState();
  const [map, setMap] = useState(/**@type window?.google?.maps?.Map*/ (null));
  const [directionResponse, setDirectionResponse] = useState();
  const [showPathSpinner, setShowPathSpinner] = useState(false);
  const [link, setLink] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const currentLocation = GeoLocation();
  const location = useLocation();

  const { from } = location?.state || "";
  const { categoryName } = location?.state || "";
  const { categoryTitle } = location?.state || "";

  let { poi } = useParams();
  var wayToHere = poi?.split(",");

  const markers = useSelector(
    (state) => state?.pointListReducer?.pointListData
  );
  const userName = useSelector(
    (state) => state?.userDetailReducer?.userData?.userName
  );

  const toggle = () => {
    setShowModal(!showModal);
    setRoute(null);
  };

  const currentCenter = {
    lat: Number(currentLocation?.coordinates?.lat),
    lng: Number(currentLocation?.coordinates?.lng),
  };

  const center = {
    lat: Number(wayToHere[0]),
    lng: Number(wayToHere[1]),
  };

  useEffect(() => {
    setTimeout(() => {
      window?.scrollTo({ top: 0, behavior: "smooth" });
    }, 0);
  }, []);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: "AIzaSyDzh8-GocyaUY-Y1vg21IVA5M0vx6RuqI8",
  });

  useEffect(() => {
    fetchPointList();
    getpoint();
  }, []);

  const fetchPointList = async () => {
    try {
      dispatch(showPointList());
    } catch (error) {
      toast.error(
        error?.startPoint?.message ||
          "Oops.. something went wrong, try again !!!",
        {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        }
      );
    }
  };

  const createNewRoute = () => {
    setShowModal(false);
    setShowCreateRouteModal(true);
  };

  const addToRoute = (id) => {
    setMkmId(id);
    setShowModal(true);
  };

  const onLoad = useCallback(function callback(map) {
    const bounds = new window.google.maps.LatLngBounds();
    bounds?.extend(center);
    bounds?.extend(currentCenter);
    map?.fitBounds(bounds);
    setMap(map);
  }, []);

  const share = (id, poi) => {
    const data = `${window?.location?.protocol}//${window?.location?.host}/category-detail/${id}/${poi}`;
    setLink(data);
    setShowShareModal(true);
  };
  const reportSuggestion = (title, id) => {
    setMkmId(id);
    setPointName(title);
    setShowReportModal(true);
  };

  const getpoint = async () => {
    let existingData;
    if (route?.id) {
      try {
        let response = await routeDetail({
          userName: userName,
          routeID: route?.id,
        });
        if (response && response?.status === 200) {
          existingData = response?.data?.data;
          console.log("Helo", existingData);
          setPointName(existingData?.title);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const selectRoute = async () => {
    let existingData;
    if (route?.id) {
      try {
        let response = await routeDetail({
          userName: userName,
          routeID: route?.id,
        });
        if (response && response?.status === 200) {
          existingData = response?.data?.data;
        }

        let requestBody = [];
        if (existingData?.length < 25) {
          if (existingData?.length === 0) {
            requestBody?.push({
              mkmID: mkmID,
              orderNumber: 0,
              visited: false,
            });
          } else if (existingData?.length === 1) {
            requestBody?.push({
              mkmID: existingData[0]?.place?.mkmID,
              orderNumber: 0,
              visited: false,
            });
            requestBody?.push({
              mkmID: mkmID,
              orderNumber: 1,
              visited: false,
            });
          } else {
            existingData?.splice(existingData?.length, 0, {
              mkmID: mkmID,
              orderNumber: existingData?.length,
              visited: false,
            });
            requestBody = existingData?.map((item, i) => {
              return {
                mkmID: item?.place?.mkmID || item?.mkmID,
                orderNumber: i,
                visited: item?.visited,
              };
            });
          }
          try {
            let res = await updateRouteDetail(requestBody, {
              userName: userName,
              routeID: route?.id,
            });
            if (res && res?.status === 200) {
              setActiveMarker(null);
              toast.success("Point Added Successfully In Your Route!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000,
              });
            }
          } catch (err) {
            toast.error(
              err?.response?.data?.message ||
                "Oops.. something went wrong, try again !!!",
              {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000,
              }
            );
          }
          setRoute("");
          setShowModal(false);
        } else {
          toast.warning(
            "Max of only 25 credits can be added to a route, Kindly remove a point to add a new point.",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            }
          );
        }
        setRoute("");
        setShowModal(false);
      } catch (error) {
        console.log(error);
      }
    }
    if (!route?.id) {
      toast.error("Please Select The Route.", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
    }
  };

  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return;
    }
    setActiveMarker(marker);
  };

  const addToFavorite = async (id, fav) => {
    if (isUserLoggedIn) {
      const willFavorite = await swal({
        title: "Are you sure?",
        text: "You want to add this route in Favorites?",
        icon: marked_pop,
        buttons: true,
      });
      if (willFavorite) {
        try {
          const obj = {
            userName: userName,
          };
          const data = {
            mkmId: id,
          };
          const response = await addUserFavorite(data, obj);
          setCheckForFavorite(fav);
          if (response && response?.status === 200) {
            swal(
              "Added!",
              "Your route has been added in Favorites!",
              "success"
            );
          }
        } catch (error) {
          toast.error(
            error?.response?.data?.message ||
              "Oops.. something went wrong, try again !!!",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            }
          );
        }
      }
    } else {
      const notLoggedIn = await swal({
        title: "Please Continue to Log In",
        text: "You want to add this route in Favorites?",
        icon: marked_pop,
        buttons: ["Cancel", "Log In"],
      });
      if (notLoggedIn) {
        navigate("/sign-in");
      }
    }
  };

  const removeFromFavorite = async (id, fav) => {
    if (isUserLoggedIn) {
      const willRemoveFavorite = await swal({
        title: "Are you sure?",
        text: "You want to remove this route from Favorites?",
        icon: marked_pop,
        buttons: true,
      });
      if (willRemoveFavorite) {
        try {
          const obj = {
            userName: userName,
          };
          const data = {
            mkmId: id,
          };
          const response = await removeUserFavorite(data, obj);
          setCheckForFavorite(fav);
          if (response && response?.status === 200) {
            swal(
              "Removed!",
              "Your route has been removed from Favorites!",
              "success"
            );
          }
        } catch (error) {
          toast.error(
            error?.response?.data?.message ||
              "Oops.. something went wrong, try again !!!",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            }
          );
        }
      }
    } else {
      const notLoggedIn = await swal({
        title: "Please Continue to Log In",
        text: "You want to remove this route from Favorites?",
        icon: marked_pop,
        buttons: ["Cancel", "Log In"],
      });
      if (notLoggedIn) {
        navigate("/sign-in");
      }
    }
  };

  const showPath = async () => {
    if (isUserLoggedIn) {
      setShowPathSpinner(true);
      let totalPoints = await getUserPoints({
        userName: userName,
      });
      if (totalPoints?.data?.data?.userPoints === 0) {
        setShowPathSpinner(false);
        const notPoints = await swal({
          title: "Failed to Show Path",
          text: "Seems like you do not have enough credits in your account.",
          icon: "warning",
          buttons: ["Cancel", "Buy Credits"],
        });
        if (notPoints) {
          navigate("/points");
        }
      } else {
        setShowPathSpinner(true);
        let data = {
          userName: userName,
          devicePlatform:
            navigator?.userAgent?.indexOf("Win") !== -1
              ? "WINDOWS"
              : navigator?.userAgent?.indexOf("Android") !== -1
              ? "ANDROID"
              : navigator?.userAgent?.indexOf("like Mac") !== -1
              ? "IOS"
              : navigator?.userAgent?.indexOf("Linux") !== -1
              ? "LINUX"
              : navigator?.userAgent?.indexOf("Mac") !== -1
              ? "MACINTOSH"
              : "",
          pointsUsed: 1,
        };
        await deductPoints(data);
        getPoints();
        const directionsService = new window.google.maps.DirectionsService();

        let start = currentCenter;

        let end = center;

        let request = {
          origin: start,
          destination: end,
          travelMode: "DRIVING",
        };

        directionsService?.route(request, function (result, status) {
          if (status === "OK") {
            setDirectionResponse(result);
            setMap(map);
            setShowPathSpinner(false);
          } else {
            toast.error("No paths found.", {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            });
            setShowPathSpinner(false);
          }
        });
      }
    } else {
      const notLoggedIn = await swal({
        title: "Please Continue to Log In",
        text: "You want to show path?",
        icon: "warning",
        buttons: ["Cancel", "Log In"],
      });
      if (notLoggedIn) {
        navigate("/sign-in");
      }
    }
  };

  const isDisabled = () => {
    if (showPathSpinner === true) {
      return true;
    }
  };

  const alongWayToHereCloseInfo = () => {
    setActiveMarker(null);
  };

  return (
    <div className="main_section along_the_way_to_here">
      <Container>
        <SelectRouteModal
          route={route}
          setRoute={setRoute}
          showModal={showModal}
          toggle={toggle}
          createNewRoute={createNewRoute}
          selectRoute={selectRoute}
        />
        <CreateNewRouteModal
          showCreateRouteModal={showCreateRouteModal}
          setShowCreateRouteModal={setShowCreateRouteModal}
          showListModal={showListModal}
          setShowListModal={setShowListModal}
          routeName={routeName}
          setRouteName={setRouteName}
          pointName={pointName}
          setPointName={setPointName}
          createNewRoute={createNewRoute}
          selectRoute={selectRoute}
        />
        <PointsListingModal
          showListModal={showListModal}
          setShowListModal={setShowListModal}
          setRouteName={setRouteName}
          routeName={routeName}
          pointName={pointName}
          setPointName={setPointName}
        />
        <ReportSuggestionModal
          showReportModal={showReportModal}
          setShowReportModal={setShowReportModal}
          showListModal={showListModal}
          setShowListModal={setShowListModal}
          setRouteName={setRouteName}
          routeName={routeName}
          pointName={pointName}
          mkmID={mkmID}
        />
        <ShareModal
          showShareModal={showShareModal}
          setShowShareModal={setShowShareModal}
          link={link}
          setLink={setLink}
        />
        {/* <SearchBar /> */}
        <div className="breadcrumb_section">
          <Container>
            {from === "alongRoute" ? (
              <Breadcrumb className="breadcrumb">
                <BreadcrumbItem>
                  <Link to="/" className="breadcrumb_item1">
                    Home
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link to="/my-routes" className="breadcrumb_item1">
                    My Routes
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link
                    to="/along-route"
                    state={{ data: location?.state?.data }}
                    className="breadcrumb_item1"
                  >
                    Along Route
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active className="breadcrumb_item2">
                  Along The Way To Here
                </BreadcrumbItem>
              </Breadcrumb>
            ) : from === "addMorePointToRoute" ? (
              <Breadcrumb className="breadcrumb">
                <BreadcrumbItem>
                  <Link to="/" className="breadcrumb_item1">
                    <GoHome />
                  </Link>
                  <span className="breadcrumb-divider">
                    <MdOutlineNavigateNext />
                  </span>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link to="/my-routes" className="breadcrumb_item1">
                    My Routes
                  </Link>
                  <span className="breadcrumb-divider">
                    <MdOutlineNavigateNext />
                  </span>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link
                    to="/add-more-points-to-route"
                    state={{ data: location?.state?.data }}
                    className="breadcrumb_item1"
                  >
                    Add more credits to route
                  </Link>
                  <span className="breadcrumb-divider">
                    <MdOutlineNavigateNext />
                  </span>
                </BreadcrumbItem>
                <BreadcrumbItem active className="breadcrumb_item2">
                  Along The Way To Here
                </BreadcrumbItem>
              </Breadcrumb>
            ) : from === "customAddress" ? (
              <Breadcrumb className="breadcrumb">
                <BreadcrumbItem>
                  <Link to="/" className="breadcrumb_item1">
                    Home
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link to="/my-routes" className="breadcrumb_item1">
                    My Routes
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link
                    to="/search-custom-point"
                    state={{ data: location?.state?.data }}
                    className="breadcrumb_item1"
                  >
                    Custom Point Address
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active className="breadcrumb_item2">
                  Along The Way To Here
                </BreadcrumbItem>
              </Breadcrumb>
            ) : from === "routeDetail" ? (
              <Breadcrumb className="breadcrumb">
                <BreadcrumbItem>
                  <Link to="/" className="breadcrumb_item1">
                    Home
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link to="/my-routes" className="breadcrumb_item1">
                    My Routes
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active className="breadcrumb_item2">
                  Along The Way To Here
                </BreadcrumbItem>
              </Breadcrumb>
            ) : from === "alongPreviousPoint" ? (
              <Breadcrumb className="breadcrumb">
                <BreadcrumbItem>
                  <Link to="/" className="breadcrumb_item1">
                    Home
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link to="/my-routes" className="breadcrumb_item1">
                    My Routes
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link
                    to="/along-route-previous-point"
                    state={{
                      from: "alongPreviousPoint",
                      data: location?.state?.data,
                    }}
                    className="breadcrumb_item1"
                  >
                    Along Route from Point{" "}
                    <span className="pointName">
                      {location?.state?.data[1]?.place?.title}
                    </span>{" "}
                    and Point{" "}
                    <span className="pointName">
                      {location?.state?.data[0]?.place?.title}
                    </span>
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active className="breadcrumb_item2">
                  Along The Way To Here
                </BreadcrumbItem>
              </Breadcrumb>
            ) : from === "exploreNearMe" ? (
              <Breadcrumb className="breadcrumb">
                <BreadcrumbItem>
                  <Link to="/" className="breadcrumb_item1">
                    Home
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link to="/explore-near-me" className="breadcrumb_item1">
                    Explore Near Me
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active className="breadcrumb_item2">
                  Along The Way To Here
                </BreadcrumbItem>
              </Breadcrumb>
            ) : from === "favourite" ? (
              <Breadcrumb className="breadcrumb">
                <BreadcrumbItem>
                  <Link to="/" className="breadcrumb_item1">
                    {" "}
                    <GoHome />
                  </Link>
                  <span className="breadcrumb-divider">
                    <MdOutlineNavigateNext />
                  </span>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link to="/favourites" className="breadcrumb_item1">
                    Favourites
                  </Link>
                  <span className="breadcrumb-divider">
                    <MdOutlineNavigateNext />
                  </span>
                </BreadcrumbItem>
                <BreadcrumbItem active className="breadcrumb_item2">
                  Along The Way To Here
                </BreadcrumbItem>
              </Breadcrumb>
            ) : from === "routeDetailExploreNearBy" ? (
              <Breadcrumb className="breadcrumb">
                <BreadcrumbItem>
                  <Link to="/" className="breadcrumb_item1">
                    Home
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link to="/my-routes" className="breadcrumb_item1">
                    My Routes
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active className="breadcrumb_item2">
                  Along The Way To Here
                </BreadcrumbItem>
              </Breadcrumb>
            ) : from === "topPlaces" ? (
              <Breadcrumb className="breadcrumb">
                <BreadcrumbItem>
                  <Link to="/" className="breadcrumb_item1">
                    Home
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link to="/" className="breadcrumb_item1">
                    Top Places
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active className="breadcrumb_item2">
                  Along The Way To Here
                </BreadcrumbItem>
              </Breadcrumb>
            ) : from === "searchEverywhere" ? (
              <Breadcrumb className="breadcrumb">
                <BreadcrumbItem>
                  <Link to="/" className="breadcrumb_item1">
                    Home
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link
                    to="/search-everywhere"
                    state={{
                      data: location?.state?.data,
                      key: location?.state?.key,
                    }}
                    className="breadcrumb_item1"
                  >
                    Categories
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active className="breadcrumb_item2">
                  Along The Way To Here
                </BreadcrumbItem>
              </Breadcrumb>
            ) : (
              <Breadcrumb className="breadcrumb">
                <BreadcrumbItem>
                  <Link to="/" className="breadcrumb_item1">
                    Home
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link to="/" className="breadcrumb_item1">
                    Category
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem>
                  <Link
                    to="/category-list"
                    state={{
                      categoryName: categoryName,
                      categoryTitle: categoryTitle,
                    }}
                    className="breadcrumb_item1"
                  >
                    {categoryName}
                  </Link>
                </BreadcrumbItem>
                <BreadcrumbItem active className="breadcrumb_item2">
                  Along The Way To Here
                </BreadcrumbItem>
              </Breadcrumb>
            )}
          </Container>
        </div>
        <div className="along_the_way_section">
          <Container fluid>
            <div className="along_the_way_box">
              <div className="map">
                {isLoaded ? (
                  <GoogleMap
                    mapContainerStyle={containerStyle}
                    zoom={12}
                    onLoad={onLoad}
                    options={options}
                  >
                    {markers?.map((item) => (
                      <div key={item?.id}>
                        <Marker
                          position={{
                            lat: Number(item?.poi?.split(",")[0]),
                            lng: Number(item?.poi?.split(",")[1]),
                          }}
                          onClick={() => handleActiveMarker(item?.id)}
                          // icon={{
                          //     url: item?.categoryId === 1
                          //         ? "http://maps.google.com/mapfiles/ms/icons/yellow-dot.png"
                          //         : item?.categoryId === 10
                          //             ? "http://maps.google.com/mapfiles/ms/icons/blue-dot.png"
                          //             : item?.categoryId === 5
                          //                 ? "http://maps.google.com/mapfiles/ms/icons/purple-dot.png"
                          //                 : item?.categoryId === 4
                          //                     ? require('../../assets/darkpurple.png')
                          //                     : item?.categoryId === 2
                          //                         ? "http://maps.google.com/mapfiles/ms/icons/ltblue-dot.png"
                          //                         : item?.categoryId === 7
                          //                             ? "http://maps.google.com/mapfiles/ms/icons/pink-dot.png"
                          //                             : item?.categoryId === 9
                          //                                 ? require('../../assets/gray.png')
                          //                                 : item?.categoryId === 12
                          //                                     ? require('../../assets/darkblue.png')
                          //                                     : require('../../assets/lightpink.png')
                          // }}

                          onLoad={(marker) => {
                            const customIcon = (opts) =>
                              Object.assign(
                                {
                                  path: "M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z",
                                  fillColor: "#34495e",
                                  fillOpacity: 1,
                                  strokeColor: "teal",
                                  strokeWeight: 2,
                                  scale: 1,
                                },
                                opts
                              );
                            item?.categoryId === 1
                              ? marker.setIcon(
                                  customIcon({
                                    fillColor: "#d2b48c",
                                    strokeColor: "white",
                                  })
                                )
                              : item?.categoryId === 10
                              ? marker.setIcon(
                                  customIcon({
                                    fillColor: "teal",
                                    strokeColor: "white",
                                  })
                                )
                              : item?.categoryId === 5
                              ? marker.setIcon(
                                  customIcon({
                                    fillColor: "turquoise",
                                    strokeColor: "white",
                                  })
                                )
                              : item?.categoryId === 4
                              ? marker.setIcon(
                                  customIcon({
                                    fillColor: "gold",
                                    strokeColor: "white",
                                  })
                                )
                              : item?.categoryId === 2
                              ? marker.setIcon(
                                  customIcon({
                                    fillColor: "#000080",
                                    strokeColor: "white",
                                  })
                                )
                              : item?.categoryId === 7
                              ? marker.setIcon(
                                  customIcon({
                                    fillColor: "#00ffff",
                                    strokeColor: "white",
                                  })
                                )
                              : item?.categoryId === 9
                              ? marker.setIcon(
                                  customIcon({
                                    fillColor: "tomato",
                                    strokeColor: "white",
                                  })
                                )
                              : item?.categoryId === 12
                              ? marker.setIcon(
                                  customIcon({
                                    fillColor: "wheat",
                                    strokeColor: "white",
                                  })
                                )
                              : marker.setIcon(
                                  customIcon({ fillColor: "green" })
                                );
                            return handleActiveMarker(marker, item);
                          }}
                        >
                          {activeMarker === item?.id ? (
                            <InfoWindow
                              onCloseClick={() => setActiveMarker(null)}
                            >
                              <div className="info_window">
                                {" "}
                                <Card body>
                                  <div className="card_header">
                                    {item?.userFavorite === true ? (
                                      <Button
                                        className="favourite_fill_icon"
                                        onClick={() =>
                                          removeFromFavorite(item?.id)
                                        }
                                      >
                                        <AiFillStar size={20} />
                                      </Button>
                                    ) : (
                                      <Button
                                        className="favourite_icon"
                                        onClick={() => addToFavorite(item?.id)}
                                      >
                                        <AiOutlineStar size={20} />
                                      </Button>
                                    )}
                                    <div className="right_section">
                                      {from === "alongRoute" ? (
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "alongRoute",
                                            data: location?.state?.data,
                                          }}
                                          className="card_link"
                                        >
                                          <CardTitle
                                            tag="h5"
                                            title={item?.mkmTitle}
                                          >
                                            {item?.mkmTitle}
                                          </CardTitle>
                                        </Link>
                                      ) : from === "addMorePointToRoute" ? (
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "addMorePointToRoute",
                                            data: location?.state?.data,
                                          }}
                                          className="card_link"
                                        >
                                          <CardTitle
                                            tag="h5"
                                            title={item?.mkmTitle}
                                          >
                                            {item?.mkmTitle}
                                          </CardTitle>
                                        </Link>
                                      ) : from === "customAddress" ? (
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "customAddress",
                                            data: location?.state?.data,
                                          }}
                                          className="card_link"
                                        >
                                          <CardTitle
                                            tag="h5"
                                            title={item?.mkmTitle}
                                          >
                                            {item?.mkmTitle}
                                          </CardTitle>
                                        </Link>
                                      ) : from === "routeDetail" ? (
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "routeDetail",
                                            data: location?.state?.data,
                                          }}
                                          className="card_link"
                                        >
                                          <CardTitle
                                            tag="h5"
                                            title={item?.mkmTitle}
                                          >
                                            {item?.mkmTitle}
                                          </CardTitle>
                                        </Link>
                                      ) : from === "alongPreviousPoint" ? (
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "alongPreviousPoint",
                                            data: location?.state?.data,
                                          }}
                                          className="card_link"
                                        >
                                          <CardTitle
                                            tag="h5"
                                            title={item?.mkmTitle}
                                          >
                                            {item?.mkmTitle}
                                          </CardTitle>
                                        </Link>
                                      ) : from === "exploreNearMe" ? (
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "exploreNearMe",
                                            data: location?.state?.data,
                                          }}
                                          className="card_link"
                                        >
                                          <CardTitle
                                            tag="h5"
                                            title={item?.mkmTitle}
                                          >
                                            {item?.mkmTitle}
                                          </CardTitle>
                                        </Link>
                                      ) : from === "favourite" ? (
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "favourite",
                                            data: location?.state?.data,
                                          }}
                                          className="card_link"
                                        >
                                          <CardTitle
                                            tag="h5"
                                            title={item?.mkmTitle}
                                          >
                                            {item?.mkmTitle}
                                          </CardTitle>
                                        </Link>
                                      ) : from ===
                                        "routeDetailExploreNearBy" ? (
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "routeDetailExploreNearBy",
                                            data: location?.state?.data,
                                          }}
                                          className="card_link"
                                        >
                                          <CardTitle
                                            tag="h5"
                                            title={item?.mkmTitle}
                                          >
                                            {item?.mkmTitle}
                                          </CardTitle>
                                        </Link>
                                      ) : from === "topPlaces" ? (
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "topPlaces",
                                            data: location?.state?.data,
                                          }}
                                          className="card_link"
                                        >
                                          <CardTitle
                                            tag="h5"
                                            title={item?.mkmTitle}
                                          >
                                            {item?.mkmTitle}
                                          </CardTitle>
                                        </Link>
                                      ) : from === "searchEverywhere" ? (
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "searchEverywhere",
                                            data: location?.state?.data,
                                            key: location?.state?.key,
                                          }}
                                          className="card_link"
                                        >
                                          <CardTitle
                                            tag="h5"
                                            title={item?.mkmTitle}
                                          >
                                            {item?.mkmTitle}
                                          </CardTitle>
                                        </Link>
                                      ) : (
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            categoryName: categoryName,
                                            categoryTitle: categoryTitle,
                                            data: location?.state?.data,
                                          }}
                                          className="card_link"
                                        >
                                          <CardTitle
                                            tag="h5"
                                            title={item?.mkmTitle}
                                          >
                                            {item?.mkmTitle}
                                          </CardTitle>
                                        </Link>
                                      )}
                                      <Dropdown
                                        className="moreInfo"
                                        toggle={() => {
                                          setMenuOpen(!dropdownMenuOpen);
                                        }}
                                        isOpen={dropdownMenuOpen}
                                      >
                                        <DropdownToggle>
                                          <BiDotsVerticalRounded size={20} />
                                        </DropdownToggle>
                                        <DropdownMenu>
                                          <DropdownItem>
                                            {from === "alongRoute" ? (
                                              <Link
                                                to={`/along-the-way-to-here/${item?.poi}`}
                                                state={{
                                                  from: "alongRoute",
                                                  data: location?.state?.data,
                                                }}
                                                onClick={
                                                  alongWayToHereCloseInfo
                                                }
                                                className="breadcrumb_item1"
                                              >
                                                Along the way to here
                                              </Link>
                                            ) : from ===
                                              "addMorePointToRoute" ? (
                                              <Link
                                                to={`/along-the-way-to-here/${item?.poi}`}
                                                state={{
                                                  from: "addMorePointToRoute",
                                                  data: location?.state?.data,
                                                }}
                                                onClick={
                                                  alongWayToHereCloseInfo
                                                }
                                                className="breadcrumb_item1"
                                              >
                                                Along the way to here
                                              </Link>
                                            ) : from === "customAddress" ? (
                                              <Link
                                                to={`/along-the-way-to-here/${item?.poi}`}
                                                state={{
                                                  from: "customAddress",
                                                  data: location?.state?.data,
                                                }}
                                                onClick={
                                                  alongWayToHereCloseInfo
                                                }
                                                className="breadcrumb_item1"
                                              >
                                                Along the way to here
                                              </Link>
                                            ) : from === "routeDetail" ? (
                                              <Link
                                                to={`/along-the-way-to-here/${item?.poi}`}
                                                state={{
                                                  from: "routeDetail",
                                                  data: location?.state?.data,
                                                }}
                                                onClick={
                                                  alongWayToHereCloseInfo
                                                }
                                                className="breadcrumb_item1"
                                              >
                                                Along the way to here
                                              </Link>
                                            ) : from ===
                                              "alongPreviousPoint" ? (
                                              <Link
                                                to={`/along-the-way-to-here/${item?.poi}`}
                                                state={{
                                                  from: "alongPreviousPoint",
                                                  data: location?.state?.data,
                                                }}
                                                onClick={
                                                  alongWayToHereCloseInfo
                                                }
                                                className="breadcrumb_item1"
                                              >
                                                Along the way to here
                                              </Link>
                                            ) : from === "exploreNearMe" ? (
                                              <Link
                                                to={`/along-the-way-to-here/${item?.poi}`}
                                                state={{
                                                  from: "exploreNearMe",
                                                  data: location?.state?.data,
                                                }}
                                                onClick={
                                                  alongWayToHereCloseInfo
                                                }
                                                className="breadcrumb_item1"
                                              >
                                                Along the way to here
                                              </Link>
                                            ) : from === "favourite" ? (
                                              <Link
                                                to={`/along-the-way-to-here/${item?.poi}`}
                                                state={{
                                                  from: "favourite",
                                                  data: location?.state?.data,
                                                }}
                                                onClick={
                                                  alongWayToHereCloseInfo
                                                }
                                                className="breadcrumb_item1"
                                              >
                                                Along the way to here
                                              </Link>
                                            ) : from ===
                                              "routeDetailExploreNearBy" ? (
                                              <Link
                                                to={`/along-the-way-to-here/${item?.poi}`}
                                                state={{
                                                  from: "routeDetailExploreNearBy",
                                                  data: location?.state?.data,
                                                }}
                                                onClick={
                                                  alongWayToHereCloseInfo
                                                }
                                                className="breadcrumb_item1"
                                              >
                                                Along the way to here
                                              </Link>
                                            ) : from === "topPlaces" ? (
                                              <Link
                                                to={`/along-the-way-to-here/${item?.poi}`}
                                                state={{
                                                  from: "topPlaces",
                                                  data: location?.state?.data,
                                                }}
                                                onClick={
                                                  alongWayToHereCloseInfo
                                                }
                                                className="breadcrumb_item1"
                                              >
                                                Along the way to here
                                              </Link>
                                            ) : from === "searchEverywhere" ? (
                                              <Link
                                                to={`/along-the-way-to-here/${item?.poi}`}
                                                state={{
                                                  from: "searchEverywhere",
                                                  data: location?.state?.data,
                                                  key: location?.state?.key,
                                                }}
                                                onClick={
                                                  alongWayToHereCloseInfo
                                                }
                                                className="breadcrumb_item1"
                                              >
                                                Along the way to here
                                              </Link>
                                            ) : (
                                              <Link
                                                to={`/along-the-way-to-here/${item?.poi}`}
                                                state={{
                                                  categoryName: categoryName,
                                                  categoryTitle: categoryTitle,
                                                  data: location?.state?.data,
                                                }}
                                                onClick={
                                                  alongWayToHereCloseInfo
                                                }
                                                className="breadcrumb_item1"
                                              >
                                                Along the way to here
                                              </Link>
                                            )}
                                          </DropdownItem>
                                          <DropdownItem
                                            onClick={() =>
                                              reportSuggestion(
                                                item?.mkmTitle,
                                                item?.id
                                              )
                                            }
                                          >
                                            Report suggestion
                                          </DropdownItem>
                                        </DropdownMenu>
                                      </Dropdown>
                                    </div>
                                  </div>
                                  <CardText className="grid_text_le">
                                    {item?.cityY + " "} &nbsp; {item?.stateY}
                                  </CardText>
                                  <div className="card_bottom">
                                    <Button
                                      onClick={() => share(item?.id, item?.poi)}
                                    >
                                      <FiShare2 size={20} />
                                    </Button>
                                    <div className="right_section">
                                      <CardText>
                                        {item?.cityE + " " + item?.stateE}
                                      </CardText>
                                      <MdLocationOn
                                        className="location_icon"
                                        size={18}
                                      />
                                    </div>
                                  </div>
                                  <div className="card_footer">
                                    {from === "alongRoute" ? (
                                      <>
                                        <Link
                                          to={`/explore-near-by/${item?.poi}`}
                                          state={{
                                            from: "alongRoute",
                                            data: location?.state?.data,
                                          }}
                                          className="btn explore"
                                        >
                                          <BiExitFullscreen className="explore_icon" />
                                          Explore Near By
                                        </Link>
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "alongRoute",
                                            data: location?.state?.data,
                                          }}
                                          className="btn viewmore"
                                        >
                                          View More
                                        </Link>
                                      </>
                                    ) : from === "addMorePointToRoute" ? (
                                      <>
                                        <Link
                                          to={`/explore-near-by/${item?.poi}`}
                                          state={{
                                            from: "addMorePointToRoute",
                                            data: location?.state?.data,
                                          }}
                                          className="btn explore"
                                        >
                                          <BiExitFullscreen className="explore_icon" />
                                          Explore Near By
                                        </Link>
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "addMorePointToRoute",
                                            data: location?.state?.data,
                                          }}
                                          className="btn viewmore"
                                        >
                                          View More
                                        </Link>
                                      </>
                                    ) : from === "customAddress" ? (
                                      <>
                                        <Link
                                          to={`/explore-near-by/${item?.poi}`}
                                          state={{
                                            from: "customAddress",
                                            data: location?.state?.data,
                                          }}
                                          className="btn explore"
                                        >
                                          <BiExitFullscreen className="explore_icon" />
                                          Explore Near By
                                        </Link>
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "customAddress",
                                            data: location?.state?.data,
                                          }}
                                          className="btn viewmore"
                                        >
                                          View More
                                        </Link>
                                      </>
                                    ) : from === "routeDetail" ? (
                                      <>
                                        <Link
                                          to={`/explore-near-by/${item?.poi}`}
                                          state={{
                                            from: "routeDetail",
                                            data: location?.state?.data,
                                          }}
                                          className="btn explore"
                                        >
                                          <BiExitFullscreen className="explore_icon" />
                                          Explore Near By
                                        </Link>
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "routeDetail",
                                            data: location?.state?.data,
                                          }}
                                          className="btn viewmore"
                                        >
                                          View More
                                        </Link>
                                      </>
                                    ) : from === "alongPreviousPoint" ? (
                                      <>
                                        <Link
                                          to={`/explore-near-by/${item?.poi}`}
                                          state={{
                                            from: "alongPreviousPoint",
                                            data: location?.state?.data,
                                          }}
                                          className="btn explore"
                                        >
                                          <BiExitFullscreen className="explore_icon" />
                                          Explore Near By
                                        </Link>
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "alongPreviousPoint",
                                            data: location?.state?.data,
                                          }}
                                          className="btn viewmore"
                                        >
                                          View More
                                        </Link>
                                      </>
                                    ) : from === "exploreNearMe" ? (
                                      <>
                                        <Link
                                          to={`/explore-near-by/${item?.poi}`}
                                          state={{
                                            from: "exploreNearMe",
                                            data: location?.state?.data,
                                          }}
                                          className="btn explore"
                                        >
                                          <BiExitFullscreen className="explore_icon" />
                                          Explore Near By
                                        </Link>
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "exploreNearMe",
                                            data: location?.state?.data,
                                          }}
                                          className="btn viewmore"
                                        >
                                          View More
                                        </Link>
                                      </>
                                    ) : from === "favourite" ? (
                                      <>
                                        <Link
                                          to={`/explore-near-by/${item?.poi}`}
                                          state={{
                                            from: "favourite",
                                            data: location?.state?.data,
                                          }}
                                          className="btn explore"
                                        >
                                          <BiExitFullscreen className="explore_icon" />
                                          Explore Near By
                                        </Link>
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "favourite",
                                            data: location?.state?.data,
                                          }}
                                          className="btn viewmore"
                                        >
                                          View More
                                        </Link>
                                      </>
                                    ) : from === "routeDetailExploreNearBy" ? (
                                      <>
                                        <Link
                                          to={`/explore-near-by/${item?.poi}`}
                                          state={{
                                            from: "routeDetailExploreNearBy",
                                            data: location?.state?.data,
                                          }}
                                          className="btn explore"
                                        >
                                          <BiExitFullscreen className="explore_icon" />
                                          Explore Near By
                                        </Link>
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "routeDetailExploreNearBy",
                                            data: location?.state?.data,
                                          }}
                                          className="btn viewmore"
                                        >
                                          View More
                                        </Link>
                                      </>
                                    ) : from === "topPlaces" ? (
                                      <>
                                        <Link
                                          to={`/explore-near-by/${item?.poi}`}
                                          state={{
                                            from: "topPlaces",
                                            data: location?.state?.data,
                                          }}
                                          className="btn explore"
                                        >
                                          <BiExitFullscreen className="explore_icon" />
                                          Explore Near By
                                        </Link>
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "topPlaces",
                                            data: location?.state?.data,
                                          }}
                                          className="btn viewmore"
                                        >
                                          View More
                                        </Link>
                                      </>
                                    ) : from === "searchEverywhere" ? (
                                      <>
                                        <Link
                                          to={`/explore-near-by/${item?.poi}`}
                                          state={{
                                            from: "searchEverywhere",
                                            data: location?.state?.data,
                                            key: location?.state?.key,
                                          }}
                                          className="btn explore"
                                        >
                                          <BiExitFullscreen className="explore_icon" />
                                          Explore Near By
                                        </Link>
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            from: "searchEverywhere",
                                            data: location?.state?.data,
                                            key: location?.state?.key,
                                          }}
                                          className="btn viewmore"
                                        >
                                          View More
                                        </Link>
                                      </>
                                    ) : (
                                      <>
                                        <Link
                                          to={`/explore-near-by/${item?.poi}`}
                                          state={{
                                            categoryName: categoryName,
                                            categoryTitle: categoryTitle,
                                            data: location?.state?.data,
                                          }}
                                          className="btn explore"
                                        >
                                          <BiExitFullscreen className="explore_icon" />
                                          Explore Near By
                                        </Link>
                                        <Link
                                          to={`/category-detail/${
                                            item?.categoryId === 12
                                              ? "?tzadikimId=" + item?.id
                                              : "?MkmId=" + item?.id
                                          }&cor=${item?.poi}`}
                                          state={{
                                            categoryName: categoryName,
                                            categoryTitle: categoryTitle,
                                            data: location?.state?.data,
                                          }}
                                          className="btn viewmore"
                                        >
                                          View More
                                        </Link>
                                      </>
                                    )}

                                    <Button
                                      className="btn addroute"
                                      onClick={() => addToRoute(item?.id)}
                                    >
                                      <FiBriefcase className="addroute_icon" />
                                      Add to Route
                                    </Button>
                                  </div>
                                </Card>
                              </div>
                            </InfoWindow>
                          ) : null}
                        </Marker>
                        <Marker
                          position={center}
                          icon={{
                            url: "http://maps.google.com/mapfiles/ms/icons/red-dot.png",
                          }}
                        />
                        <Marker
                          position={currentCenter}
                          icon={{
                            url: "http://maps.google.com/mapfiles/ms/icons/green-dot.png",
                          }}
                        />
                      </div>
                    ))}
                    {isUserLoggedIn && (
                      <>
                        {directionResponse && (
                          <DirectionsRenderer directions={directionResponse} />
                        )}
                      </>
                    )}
                  </GoogleMap>
                ) : (
                  <></>
                )}
                <div className="map_footer">
                  <Button onClick={() => showPath()} disabled={isDisabled()}>
                    {showPathSpinner === true ? (
                      <Spinner size="sm"></Spinner>
                    ) : (
                      <>
                        Show Path
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle
                            cx="12"
                            cy="12"
                            r="11"
                            stroke="#FFFFFF"
                            strokeWidth="2"
                          />
                          <path
                            d="M7.4375 6.9375H8.70312L15.8281 15.6719V6.9375H17.1172V18H15.9062L8.72656 9.20312V18H7.4375V6.9375Z"
                            fill="#FFFFFF"
                          />
                          <path
                            d="M7.4375 6.9375V6.4375H6.9375V6.9375H7.4375ZM8.70312 6.9375L9.09057 6.62145L8.94051 6.4375H8.70312V6.9375ZM15.8281 15.6719L15.4407 15.9879L16.3281 17.0758V15.6719H15.8281ZM15.8281 6.9375V6.4375H15.3281V6.9375H15.8281ZM17.1172 6.9375H17.6172V6.4375H17.1172V6.9375ZM17.1172 18V18.5H17.6172V18H17.1172ZM15.9062 18L15.5189 18.3162L15.6689 18.5H15.9062V18ZM8.72656 9.20312L9.11392 8.88697L8.22656 7.79974V9.20312H8.72656ZM8.72656 18V18.5H9.22656V18H8.72656ZM7.4375 18H6.9375V18.5H7.4375V18ZM7.4375 7.4375H8.70312V6.4375H7.4375V7.4375ZM8.31568 7.25355L15.4407 15.9879L16.2156 15.3558L9.09057 6.62145L8.31568 7.25355ZM16.3281 15.6719V6.9375H15.3281V15.6719H16.3281ZM15.8281 7.4375H17.1172V6.4375H15.8281V7.4375ZM16.6172 6.9375V18H17.6172V6.9375H16.6172ZM17.1172 17.5H15.9062V18.5H17.1172V17.5ZM16.2936 17.6838L9.11392 8.88697L8.3392 9.51928L15.5189 18.3162L16.2936 17.6838ZM8.22656 9.20312V18H9.22656V9.20312H8.22656ZM8.72656 17.5H7.4375V18.5H8.72656V17.5ZM7.9375 18V6.9375H6.9375V18H7.9375Z"
                            fill="#FFFFFF"
                          />
                        </svg>
                      </>
                    )}
                  </Button>
                </div>
              </div>
            </div>
          </Container>
        </div>
      </Container>
    </div>
  );
}

export default AlongTheWayToHere;
